import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { fileTypeIcon } from '@app/helpers/fileDownload';
import { FileInfo } from '@app/models/document.model';
import { DownloadService } from '@app/services/file/download.service';

@Component({
  selector: 'app-downloadable-file-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './downloadable-file-card.component.html',
  styleUrl: './downloadable-file-card.component.scss',
})
export class DownloadableFileCardComponent {
  private readonly downloadService = inject(DownloadService);

  file = input.required<FileInfo>();

  protected getIconClass(): string {
    return fileTypeIcon(this.file());
  }

  protected getSizeKb(): number | null {
    const size = this.file()?.size;
    return size != null ? Math.round(size / 1024) : null;
  }

  protected onDownload(): void {
    const f = this.file();
    if (!f?.id) return;
    this.downloadService
      .downloadFileById(f.id, f.name ?? 'document')
      .subscribe();
  }
}
